import { lazy, Suspense } from 'react';
import { BrowserRouter, useRoutes, RouteObject, useLocation } from 'react-router-dom';
import Panel from './views/Panel'
import Login from './views/entrance/Login';
import Register from './views/entrance/Register';
import FindPw from './views/entrance/FindPw';
import Webview from './views/Webview'
import { useEffect, get, useNavigate, config } from '@/common';

// 404处理
let default_url: any = null

const NoPage = () => {
    const navigate = useNavigate()
    useEffect(() => {
        navigate(default_url ? default_url : '/login');
    }, [])
    return (<></>)
}

// 固定页面
let routes: RouteObject[] = [
    {
        element: <Panel />,
        children: []
    },
    {
        path: 'login',
        element: <Login />
    },
    {
        path: 'find_pw',
        element: <FindPw />
    },
    {
        path: 'webview/:type/:key',
        element: <Webview />
    },
    {
        path: '*',
        element: <NoPage />
    }
]

let Routes = () => {
    return useRoutes(routes)
}

// 平台初始化操作
const setDefault = () => {
    // 获取常量
    get('/opens/constants').then(data => {
        localStorage.setItem('constants', JSON.stringify(data.data))
    })
    // 获取配置
    get('/system/config').then(data => {
        data = data.data
        localStorage.setItem('config', JSON.stringify(data))
        // 设置网页标题
        let title = config.name
        if (data.system && data.system.name) {
            title = data.system.name
        }
        document.title = title
    })
    // 获取组织配置
    if (localStorage.getItem('member')) {
        get('/system/organization/getConfig').then(data => {
            localStorage.setItem('config_organization', JSON.stringify(data.data))
        })
    }
    getModules(JSON.parse(localStorage.getItem('module') || '[]'))
}

function Main() {
    setDefault()

    return (
        <BrowserRouter>
            <Routes />
        </BrowserRouter>
    )
}

// 无限级处理
const getModules = (m: any) => {
    m.forEach((e: any) => {
        if (e.children) {
            getModules(e.children)
        } else if (routes[0].children) {
            if (!routes[0].children.length) default_url = e.url
            const Element = lazy(() => import(`@/views${pathToModule(e.url)}`))
            routes[0].children.push({
                path: e.url,
                element: <Suspense fallback={null}><Element ope={e.ope || []} title={e.name} /></Suspense>
            })
        }
    });
}

// 路径转换模块名
const pathToModule = (path: string) => {
    let arr: string[] = path.split('/')
    let module: string[] = arr.splice(arr.length - 1, 1)[0].split('_')
    module.forEach((e, i) => {
        module[i] = e.charAt(0).toUpperCase() + e.slice(1)
    });
    return arr.join('/') + '/' + module.join('')
}

export default Main